"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var cookie_1 = require("./cookie");
var root = require("window-or-global");
var query = require("query-string");
var Cookies = require("js-cookie");
var localStorageInfo = function () {
    if (!root.localStorage) {
        return {};
    }
    var timestamp = localStorage.getItem('aida_contact_agencyId_timestamp');
    if (new Date().getTime() - parseInt(timestamp) > 30 * 24 * 60 * 60) {
        return {};
    }
    return {
        agencyId: localStorage.getItem('aida_contact_agencyId'),
        agencyIdTimestamp: timestamp,
    };
};
var setLocalStorageInfo = function (agency) {
    if (!root.localStorage) {
        return;
    }
    localStorage.setItem('aida_contact_agencyId', agency);
    localStorage.setItem('aida_contact_agencyId_timestamp', new Date().getTime().toString());
};
exports.default = (function ($store) { return __awaiter(_this, void 0, void 0, function () {
    var location, params, aff_id_from_cookie, aff_id_via_get_parameter, aidaSource, userType, localStorageAgencyId, agencyId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                // cookie weiche
                if (root.document) {
                    cookie_1.initModule();
                }
                location = root.location ? root.location : {};
                params = query.parse(location.search);
                aff_id_from_cookie = Cookies.get('aff_id2');
                aff_id_via_get_parameter = params.utm_medium &&
                    params.utm_medium.toLowerCase() === 'ipp' &&
                    params.affID2;
                if (!($store && location.search)) return [3 /*break*/, 10];
                if (!aff_id_via_get_parameter) return [3 /*break*/, 2];
                return [4 /*yield*/, $store.dispatch('tracking/bea/setAffilliate', params.affID2)];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2:
                aidaSource = params.aidaSource || params.aidasource;
                userType = params.userType || params.usertype;
                if (!aidaSource) return [3 /*break*/, 4];
                return [4 /*yield*/, $store.dispatch('tracking/bea/setAidaSource', aidaSource)];
            case 3:
                _a.sent();
                return [3 /*break*/, 8];
            case 4:
                if (!params.origin) return [3 /*break*/, 6];
                return [4 /*yield*/, $store.dispatch('tracking/bea/setAidaSource', params.origin)];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6:
                if (!(params.source &&
                    params.source === 'com.markveys.aida.app.phone')) return [3 /*break*/, 8];
                return [4 /*yield*/, $store.dispatch('tracking/bea/setAidaSource', 'app')];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8:
                if (!userType) return [3 /*break*/, 10];
                return [4 /*yield*/, $store.dispatch('tracking/bea/setUserType', userType)];
            case 9:
                _a.sent();
                _a.label = 10;
            case 10:
                if (!($store && aff_id_from_cookie && !aff_id_via_get_parameter)) return [3 /*break*/, 12];
                return [4 /*yield*/, $store.dispatch('tracking/bea/setAffilliate', aff_id_from_cookie)];
            case 11:
                _a.sent();
                _a.label = 12;
            case 12:
                localStorageAgencyId = localStorageInfo().agencyId;
                if (!(params.agencyId || localStorageAgencyId)) return [3 /*break*/, 14];
                agencyId = params.agencyId ? params.agencyId : localStorageAgencyId;
                return [4 /*yield*/, $store.commit('tracking/bea/SET_AGENCY_ID', agencyId)];
            case 13:
                _a.sent();
                setLocalStorageInfo(agencyId);
                _a.label = 14;
            case 14: return [2 /*return*/];
        }
    });
}); });
//# sourceMappingURL=init.js.map